import React, { useLayoutEffect } from "react";
import { App as AntdApp } from "antd";

type TAppFeedbackApi = ReturnType<typeof AntdApp.useApp>;

let appFeedbackApi: TAppFeedbackApi | null = null;

export const getAppFeedbackApi = (): TAppFeedbackApi | null => appFeedbackApi;

const AppFeedback: React.FC = () =>
{
    const api = AntdApp.useApp();

    useLayoutEffect(() =>
    {
        appFeedbackApi = api;

        return () =>
        {
            if (appFeedbackApi === api) {
                appFeedbackApi = null;
            }
        };
    }, [ api ]);

    return null;
};

export default AppFeedback;
